import React from 'react'
import PropTypes from 'prop-types'
import { SL_GATE, MODAL_TYPE } from 'Defaults/modals'
import AppButton from 'Components/AppButton'


export const getSaveSearchModalData = ({ gate, schoolDetail }) => ({
  modalType: MODAL_TYPE.SAVE_SEARCH,
  modalSource: 'Save Search Button',
  modalData: { gate: gate || SL_GATE.AREA_ALERT, schoolDetail },
})

export const getLoginModalData = () => ({
  modalType: MODAL_TYPE.LOGIN,
  modalSource: 'Save Search Button',
  modalData: {
    // @todo use data from default after merge dev
    gate: 'SEARCH_GET_ALERT',
  },
  nextModalType: MODAL_TYPE.SAVE_SEARCH,
})

const GetAlertBtn = (
  {
    children,
    gate,
    userIsAuthentificated,
    openModal = () => {},
    googleAnalyticsEvent = () => {},
    className,
    small = false,
    primary = false,
    plain = false,
    disabled = false,
    schoolDetail,
    schoolEnabled,
  }) => {
  const getAlertClick = (e) => {
    e.stopPropagation()
    if(userIsAuthentificated) {
      // setShowSaveSearchState(true)
      const modalData = schoolEnabled
        ? getSaveSearchModalData({ gate, schoolDetail })
        : getSaveSearchModalData({ gate })
      openModal(modalData)
      googleAnalyticsEvent({
        category: 'search',
        action: '[Get alert click]',
      })
    } else {
      openModal(getLoginModalData())
    }
  }
  return (
    <AppButton
      data-test-id="getAlertBtn"
      small={small}
      primary={primary}
      plain={plain}
      onClick={getAlertClick}
      className={className}
      disabled={disabled}
    >
      {
        children
      }
    </AppButton>
  )
}

GetAlertBtn.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.node,
  gate: PropTypes.string,
  userIsAuthentificated: PropTypes.bool,
  openModal: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  className: PropTypes.string,
  small: PropTypes.bool,
  primary: PropTypes.bool,
  plain: PropTypes.bool,
  schoolDetail: PropTypes.shape({}),
  schoolEnabled: PropTypes.bool,
}

export default GetAlertBtn
